<template>
  <div>
    <transition :name="transitionNames[1]">
      <div class="maskModal" v-show="visible" @click="mask"></div>
    </transition>
    <div :class="wrapClasses" @click="handleWrapClick" @touchmove.prevent>
      <transition :name="transitionNames[0]">
        <div :class="modalClasses" v-show="visible" :style="mainStyles">
          <div class="modal-content">
            <div class="modal-header" v-if="closeBtn">
              <a-button v-if="hasCloseIcon" class="close" @click="close">
                &times;
              </a-button>
            </div>
            <div class="modal-body">
              <h4 v-if="title" class="modal-title text-center">{{ title }}</h4>
              <slot name="title"></slot>
              <slot name="body"></slot>
            </div>
            <div class="modal-footer" v-if="!customFooter && hasFooter">
              <a-button v-if="cancelBtn" class="tkn-btn " @click="cancel">
                {{ cancelText }}
              </a-button>
              <a-button type="primary" v-if="okBtn" class="tkn-btn tkn-btn_default" @click="ok">
                <span class="">{{ okText }}</span>
              </a-button>
            </div>
            <div class="modal-footer" v-if="customFooter && hasFooter">
              <slot name="footer"></slot>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>
<script>
import modalMixin from './modalMixin.js'
const prefixCls = 'new-modal'
export default {
  data() {
    return {
      visible: this.value,
      wrapShow: false
    }
  },
  props: {
    //header close
    closeBtn: {
      type: Boolean,
      default: true
    },
    draggable: {
      type: Boolean,
      default: false
    },
    value: {
      type: Boolean,
      default: false
    },
    transitionNames: {
      type: Array,
      default() {
        return ['ease', 'fade']
      }
    },
    title: {
      type: String,
      default: ''
    },
    styles: {
      type: Object
    },
    cancelText: {
      type: String,
      default: '取消'
    },
    okText: {
      type: String,
      default: '确定'
    },
    fullscreen: {
      type: Boolean,
      default: false
    },
    width: {
      type: [Number, String],
      default: 400
    },
    maskClosable: {
      type: Boolean,
      default: false
    },
    //是否展示modal-footer
    hasFooter: {
      type: Boolean,
      default: true
    },
    cancelBtn: {
      type: Boolean,
      default: true
    },
    customFooter: {
      type: Boolean,
      default: false
    },
    okBtn: {
      type: Boolean,
      default: true
    },
    footerBtn: {
      type: Boolean,
      default: true
    },
    hasCloseIcon: {
      type: Boolean,
      default: true
    }
  },
  model: {
    prop: 'value',
    event: 'on_cancel'
  },
  mixins: [modalMixin],
  watch: {
    value(val) {
      this.visible = val
    },
    visible(val) {
      if (val) {
        this.wrapShow = true
        document.body.style.overflow = 'hidden'
      } else {
        if (this.draggable) {
          this.unRegister() // 弹窗还原初识位置
        }
        this.wrapShow = false
        document.body.style.overflow = ''
      }
    }
  },
  computed: {
    wrapClasses() {
      return [
        `${prefixCls}-wrap`,
        {
          [`${prefixCls}-hidden`]: !this.wrapShow
        }
      ]
    },
    modalClasses() {
      return [
        'modal-dialog',
        {
          'modal-dialog-fullscreen': this.fullscreen
        }
      ]
    },
    mainStyles() {
      let style = {}

      const width = parseInt(this.width)
      const styleWidth = {
        width: width <= 100 ? `${width}%` : `${width}px`
      }

      const customStyle = this.styles ? this.styles : {}

      Object.assign(style, styleWidth, customStyle)

      return style
    }
  },
  mounted() {
    if (this.visible) {
      this.wrapShow = true
    }
    if (this.draggable) {
      this.registerDraggable()
    }
  },
  methods: {
    close() {
      this.visible = false
      this.$emit('on_cancel', this.visible)
    },
    mask() {
      if (this.maskClosable) {
        this.close()
      }
    },
    cancel() {
      this.close()
    },
    ok() {
      this.$emit('on_ok')
    },
    handleWrapClick(event) {
      const className = event.target.getAttribute('class')
      if (className && className.indexOf(`${prefixCls}-wrap`) > -1) this.mask()
    }
  }
}
</script>
<style lang="scss" scoped>
.maskModal {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(55, 55, 55, 0.6);
  height: 100%;
  z-index: 1000;
}
.modal-dialog {
  position: relative;
  outline: 0;
  color: #333;
  width: auto;
  margin: 30px auto;
}
.modal-title {
  text-align: center;
  height: 28px;
  font-size: 20px;
  margin-bottom: 20px;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  color: rgba(0, 0, 0, 1);
  line-height: 28px;
}
.new-modal-wrap {
  position: fixed;
  overflow: auto;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1000;
  -webkit-overflow-scrolling: touch;
  outline: 0;
}
.new-modal-hidden {
  display: none !important;
}
.modal-dialog-fullscreen {
  width: 100% !important;
  top: 0;
  bottom: 0;
  position: absolute;
}
.new-modal-header {
  border-bottom: 0px;
  text-align: center;
}
button.close {
  -webkit-appearance: none;
  padding: 0;
  cursor: pointer;
  background: transparent;
  border: 0;
  float: right;
}
.modal-open {
  overflow: hidden;
}
.modal {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1050;
  display: none;
  overflow: hidden;
  -webkit-overflow-scrolling: touch;
  outline: 0;
}
.modal.fade .modal-dialog {
  -webkit-transition: -webkit-transform 0.1s ease-out;
  -o-transition: -o-transform 0.1s ease-out;
  transition: transform 0.1s ease-out;
  -webkit-transform: translate(0, -25%);
  -ms-transform: translate(0, -25%);
  -o-transform: translate(0, -25%);
  transform: translate(0, -25%);
}
.modal.in .modal-dialog {
  -webkit-transform: translate(0, 0);
  -ms-transform: translate(0, 0);
  -o-transform: translate(0, 0);
  transform: translate(0, 0);
}
.modal-open .modal {
  overflow-x: hidden;
  overflow-y: auto;
}
.modal-content {
  position: relative;
  background-color: #fff;
  -webkit-background-clip: padding-box;
  background-clip: padding-box;
  border: 1px solid #999;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 6px;
  outline: 0;
  -webkit-box-shadow: 0 3px 9px rgba(0, 0, 0, 0.5);
  box-shadow: 0 3px 9px rgba(0, 0, 0, 0.5);
}
.modal-backdrop {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1040;
  background-color: #000;
}
.modal-backdrop.fade {
  filter: alpha(opacity=0);
  opacity: 0;
}
.modal-backdrop.in {
  filter: alpha(opacity=50);
  opacity: 0.5;
}
.modal-header {
  padding: 13px;
  text-align: center;
  /* border-bottom: 1px solid #e5e5e5; */
}
.modal-header .close {
  margin-top: -12px;
  font-size: 30px;
}
.modal-body {
  position: relative;
  padding: 20px 40px;
  // padding: 5% 10%;
  .custom-tit {
    vertical-align: middle;
    padding-left: 10px;
    height: 24px;
    font-size: 16px;
    font-family: PingFangSC-Medium;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.85);
    line-height: 24px;
  }
  .custom-body {
    padding: 10px 30px 0px 30px;
  }
}
.modal-footer {
  padding: 0px 15px 15px;
  text-align: right;
}
.modal-footer .tkn-btn + .tkn-btn {
  margin-bottom: 0;
  margin-left: 5px;
}
/* .modal-footer .btn-group .btn + .btn {
  margin-left: -1px;
}
.modal-footer .btn-block + .btn-block {
  margin-left: 0;
} */
.modal-scrollbar-measure {
  position: absolute;
  top: -9999px;
  width: 50px;
  height: 50px;
  overflow: scroll;
}
</style>
